import Vue from "vue";
import Vuex from "vuex";
import axios from "@/axios";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    jsonWebToken: localStorage.getItem("jsonWebToken")
      ? localStorage.getItem("jsonWebToken")
      : null,
    userEmail: null,
    userFirstName: null,
    userLastName: null,
    userPhoneNumber: null,
    formErrors: {}
  },
  mutations: {
    setAuthCredentials(state, authData) {
      state.jsonWebToken = authData.token;
      localStorage.setItem("jsonWebToken", authData.token);
    },
    clearAuthCredentials(state) {
      state.jsonWebToken = null;
      localStorage.removeItem("jsonWebToken");
      router.push({ name: "Login" });
    },
    setUserInfo(state, user) {
      state.userEmail = user.email;
      state.userFirstName = user.first_name;
      state.userLastName = user.last_name;
      state.userPhoneNumber = user.phone;
    },
    clearUserInfo(state) {
      state.userEmail = null;
      state.userFirstName = null;
      state.userLastName = null;
      state.userPhoneNumber = null;
    },
    setFormErrors(state, errors) {
      state.formErrors = errors;
    },
    clearFormErrors(state) {
      state.formErrors = {};
    }
  },
  actions: {
    login({ commit }, credentials) {
      axios
        .post("/auth/login", {
          email: credentials.email,
          password: credentials.password
        })
        .then(response => {
          commit("setAuthCredentials", {
            token: response.data.access_token
          });

          commit("setUserInfo", response.data.user);

          router.push({ name: "Dashboard" });
        })
        .catch(() => {}); // See axios config for basic error handling
    },
    tryAutoLogin({ commit }) {
      axios.get("/user").then(response => {
        if(response.data.user) {
          commit("setUserInfo", response.data.user);
        }
      });
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.jsonWebToken !== null;
    },
    jsonWebToken(state) {
      return state.jsonWebToken;
    },
    user(state) {
      return {
        firstname: state.userFirstName,
        lastname: state.userLastName,
        email: state.userEmail,
        phone: state.userPhoneNumber
      };
    },
    // hasValidationError(state, input) {
    //   return Object.prototype.hasOwnProperty.call(state.formErrors, input);
    // },
    hasValidationError: (state) => (input) => {
      return Object.prototype.hasOwnProperty.call(state.formErrors, input);
    },
    getValidationError: (state) => (input) => {
      if (Object.prototype.hasOwnProperty.call(state.formErrors, input)) {
        const error = state.formErrors[input];

        return Array.isArray(error) ? error[0] : error;
      }

      return null;
    }
  }
});
